<app-navbar></app-navbar>
    <div class="container mb-4 mt-4">
        <div class="row">
            <div class="col-lg-12">
                <div class="text-center inter rounded-2 careers">
                    <h3 class="fs-3">We are building and strenghtening the future of the Philippine pharmaceuticals.</h3>
                    <div class="display-2 fw-semibold">Join us so we can make it happen</div>
                </div>
            </div>
        </div>
    </div>
    @if(isLoading()) {
        <div class="container">
            <div class="row">
                @for (item of [].constructor(6); track $index) {
                    <div class="col-lg-4">
                        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '210px', 'margin-bottom': '10px', 'width': '100%' }"></ngx-skeleton-loader>
                    </div>
                }
            </div>
        </div>
    }
    @if(!isLoading()){
        @if(careers()?.length > 0){
            <div class="container mt-4">
                <div class="row">
                    <div class="col-lg-12">
                        <h4 class="text-center fs-3 fw-bold mb-4">{{careers()?.length}} Open Position{{careers()?.length > 1 ? 's' : ''}}</h4>
                    </div>
                </div>
                <div class="row">
                    @for (obj of careers(); track obj.slug) {
                        <div class="col-lg-4">
                            <div class="openings rounded-lg p-4 mb-4">
                                <div class="inter fs-6 fw-semibold mb-3">
                                    <div class="container p-0">
                                        <div class="row">
                                            <div class="col-lg-8 text-start" [title]="obj.title">{{obj.title | truncate: 30}}</div>
                                            <div class="col-lg-4 text-end">
                                                <span class="job-type" [ngClass]="{
                                                    'bg-danger': obj.jobType == 'intern',
                                                    'bg-primary': obj.jobType == 'part-time',
                                                    'bg-success': obj.jobType == 'full-time'
                                                }"></span>
                                                <span [ngClass]="{
                                                    'text-danger': obj.jobType == 'intern',
                                                    'text-primary': obj.jobType == 'part-time',
                                                    'text-success': obj.jobType == 'full-time'
                                                }">{{obj.jobType | titlecase}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="inter fs-6 pt-2 lh-lg">{{obj.description | truncate: 80}}</div>
                                <div class="inter fs-6 fw-medium mt-4">
                                    <div class="container p-0">
                                        <div class="row">
                                            <div class="col-lg-5 text-start" [title]="obj.department">{{obj.department | truncate : 16}}</div>
                                            <div class="col-lg-7 text-end text-secondary" [title]="obj.workLocation">{{obj.workLocation | truncate: 17}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3 mb-2">
                                    <a [routerLink]="['/career', obj.slug]" class="text-decoration-none inter fs-6 fw-medium border border-secondary rounded-1 apply-now">Apply Now</a>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    }
    <div class="container pb-2 mt-4 mb-5">
        <div class="row">
            <div class="col-lg-12">
                <h4 class="text-center fs-3 fw-bold mb-5">3 Steps Application Process</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="apc mb-4">
                    <h4 class="fw-semibold mt-0 text-black"><img src="assets/icons/pencil.svg" alt="Apply for the role" class="ap bg-white rounded-circle"> Apply for the role</h4>
                    <p class="inter lh-lg text-black mt-4 mb-0 fs-6">Find the role you want to apply for, fill out the application in the career page, and then click ‘Apply for this job’.</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="apc mb-4">
                    <h4 class="fw-semibold mt-0 text-black"><img src="assets/icons/notif.svg" alt="Receive an email notification" class="ap bg-white rounded-circle">Receive an email notification</h4>
                    <p class="inter lh-lg text-black mt-4 mb-0 fs-6">You will receive an email notification letting you know that we received your application. That email may take a few minutes to arrive in your inbox.</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="apc mb-4">
                    <h4 class="fw-semibold mt-0 text-black"><img src="assets/icons/calendar_2.svg" alt="Wait for interview scheduling" class="ap bg-white rounded-circle"> Wait for interview scheduling</h4>
                    <p class="inter lh-lg text-black mt-4 mb-0 fs-6">If we move your application forward, we will reach out to you within 15 business days to schedule an interview.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="container pt-2 pb-2 mt-5 mb-5">
        <div class="row">
            <div class="col-lg-4">
                <div class="working">
                    <div class="display-5 inter fw-bold text-secondary pt-5 pb-2 mb-1">People working at</div>
                    <div class="inter display-2 fw-bold">Bewell</div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="testimonial-container p-4 rounded">
                    <div class="fs-6 inter fw-medium lh-lg testimonial">
                        <p class="mb-0">"This company helps me to grow professionally and personally. They helped me to increase my knowledge of various computer applications and to develop my personal skills. I characterize our working environment as having a great work-life balance. We work in the office and when we get home, we don't bring our work at home"</p>
                    </div>
                    <div class="inter fw-semibold mt-2 mb-2">Ronnel Mangalos</div>
                    <div class="inter fw-medium text-secondary">Graphic Artist</div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="testimonial-container p-4 rounded">
                    <div class="fs-6 inter fw-medium lh-lg testimonial">
                        <p class="mb-0">"The mentorship and guidance I’ve received from my managers and colleagues have been invaluable. They’ve helped me improve not only in my day-to-day responsibilities but also in long-term career planning and personal growth."</p>
                    </div>
                    <div class="inter fw-semibold mt-2 mb-2">John Lord Santos</div>
                    <div class="inter fw-medium text-secondary">IT Admin Assistant</div>
                </div>
            </div>
        </div>
    </div>
<app-footer></app-footer>